
import { processarFilaImpressao } from "../services/restaurantePrintQueue";

const REFRESH_INTERVAL_MS = 60000;

export default {
  name: "RestaurantePrintQueueWorker",
  data() {
    return {
      intervalo: null,
      avisoFalha: false,
      processando: false,
    };
  },
  mounted() {
    this.processar();
    this.intervalo = window.setInterval(
      () => this.processar(),
      REFRESH_INTERVAL_MS
    );
    document.addEventListener("visibilitychange", this.onVisibilityChange);
  },
  beforeDestroy() {
    window.clearInterval(this.intervalo);
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
  },
  methods: {
    onVisibilityChange() {
      if (!document.hidden) this.processar();
    },
    async processar() {
      if (this.processando) return;
      this.processando = true;
      let falhou = false;
      const avisar = (error) => {
        falhou = true;
        if (this.avisoFalha) return;
        this.avisoFalha = true;
        this.$toast.warning(
          error?.message || "Existem tickets pendentes de impressão no Restaurante."
        );
      };

      try {
        await processarFilaImpressao(this.$http, { onError: avisar });
        if (!falhou) this.avisoFalha = false;
      } catch (error) {
        avisar(error);
      } finally {
        this.processando = false;
      }
    },
  },
};
